import { useQuery } from '@tanstack/react-query';
import { plainToClass } from 'class-transformer';
import { keyBy } from 'lodash';

import { offersApi } from 'api';
import { type ApiQueryOptions } from 'hooks/api/queryHelper';
import {
  type IOffersData,
  type Offer,
  Offers,
  transformToOfferClass,
} from 'models/Offers';

export const fetchOffers = async () => {
  const [error, response] = await offersApi.fetchOffers();

  if (error) {
    throw error;
  } else {
    return response;
  }
};

export const transformOffers = (data: IOffersData): Offers => {
  const offers: Record<string, Offer> = keyBy(
    data.offers.map((offer) => transformToOfferClass(offer)),
    'name',
  );

  const renewOffer: Offer | undefined = transformToOfferClass(
    data?.renewOffers?.[0],
  );

  return plainToClass(Offers, { offers, renewOffer });
};

const useFetchOffers = (options: ApiQueryOptions = {}) => {
  return useQuery({
    queryKey: ['fetchOffers'],
    queryFn: () => fetchOffers(),
    select: transformOffers,
    ...options,
  });
};

export default useFetchOffers;
